module.exports = __webpack_public_path__ + "img/IMG-20200914-WA0010.1375b32a.jpg";